import styled from "styled-components";

export const Box = styled.div`
overflow: hidden;

.interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
  .reverse-image-container {
    max-width: 700px;
    // margin-top: 3rem;
    // margin-bottom: 3rem;
  }
    html, body {
  margin: 0 !important;
  padding: 0 !important;
  overflow-x: hidden;
}

.reverse-image-card {
  margin-bottom: 0 !important;
}
  .glass-card {
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    border-radius: 15px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.18);
    overflow: hidden;
  }

  .gradient-text {
    background: linear-gradient(45deg, #000000);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-weight: 700;
  }

  .custom-tabs .nav-link {
    border: none;
    color: #6c757d;
    font-weight: 500;
    padding: 0.75rem 1rem;
    transition: all 0.3s ease;
  }

  .custom-tabs .nav-link:hover {
    color: #0d6efd;
    transform: translateY(-2px);
  }

  .custom-tabs .nav-link.active {
    color: #0d6efd;
    background: transparent;
    border-bottom: 3px solid #0d6efd;
  }

  .modern-input {
    border-radius: 10px;
    padding: 0.75rem 1.25rem;
    border: 1px solid #e0e0e0;
    transition: all 0.3s ease;
    box-shadow: none;
  }

  .modern-input:focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    transform: translateY(-1px);
  }

  .upload-label {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background-color: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    color: #495057;
  }

  .upload-label:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
    transform: translateY(-2px);
  }

  .upload-preview,
  .capture-preview {
    max-width: 100%;
    max-height: 200px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;
  }

  .search-engines {
    background: rgba(248, 249, 250, 0.7);
    padding: 1.5rem;
    border-radius: 12px;
    margin-bottom: 1.5rem;
  }

  .engine-btn {
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    transition: all 0.3s ease;
    border: none;
    position: relative;
    overflow: hidden;
  }

  .engine-btn.active {
    box-shadow: 0 5px 15px rgba(13, 110, 253, 0.3);
  }

  .engine-btn:not(.active):hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .engine-icon {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }

  .engine-name {
    font-size: 0.9rem;
    font-weight: 500;
  }

  .search-btn {
    border-radius: 10px;
    padding: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
    background: #8CC540;
    border: none;
    box-shadow: 0 4px 6px rgba(40, 167, 69, 0.2);
  }

  .search-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(40, 167, 69, 0.3);
  }

  .camera-view {
    width: 100% !important;
    max-height: 400px;
    border-radius: 10px;
    background: #000;
  }

  @media (max-width: 768px) {
    .engine-btn {
      width: 80px;
      height: 80px;
      padding: 0.5rem;
    }

    .engine-icon {
      font-size: 1.5rem;
    }

    .custom-tabs .nav-link {
      padding: 0.5rem;
      font-size: 0.85rem;
    }
      .p-4 {
    padding: 0rem !important;
  }
  }
`;
